var React = require('react');

function ArrowDownBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 1.89444L13.7919 5.95421e-08L8.0386 5.16514L2.15789 0.112786L1.262e-08 2.05306L8.08989 9L16 1.89444Z","fill":"#2B40C7"}));
}

ArrowDownBlue.defaultProps = {"width":"16","height":"9","viewBox":"0 0 16 9","fill":"none"};

module.exports = ArrowDownBlue;

ArrowDownBlue.default = ArrowDownBlue;
